
export const extension = {
  'extension.assistant': 'AgriTool Assistant',
  'extension.appAssistant': 'Application Assistant',
  'extension.appAssistantDesc': 'We\'ve detected you\'re filling out an EU subsidy application',
  'extension.appCompletion': 'Application completion',
  'extension.letsHelp': 'Let\'s help you complete this application.',
  'extension.almostComplete': 'Great! Your form is almost complete — let\'s finish it together.',
  'extension.excellent': 'Excellent! Your application is complete and ready to submit.',
  'extension.autofillProfile': 'Autofill from Farm Profile',
  'extension.requiredDocs': 'Required Documents',
  'extension.useCompletedPDF': 'Use Completed PDF from AgriTool',
  'extension.fillFormHelp': 'I can help you fill this form using data from your farm profile.',
  'extension.goodStart': 'You\'ve made a good start! I\'ve suggested some text for the remaining fields.',
  'extension.greatProgress': 'Great progress! You still need to upload the irrigation declaration form before submitting.',
  'extension.perfect': 'Perfect! Your application is complete. You can now submit it to the EU portal.',
  'extension.reviewReminder': 'Don\'t forget to review all details before final submission',
  'extension.readyToSubmit': 'Ready to Submit',
} as const;
